import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "./../../components/Navbar";
import TopBar from "./../../components/topbar";
import { safetyFeatureService } from "../../_services";
import constant from "../../_config/constant";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import Footer from "./../../layout/footer";
import Tippy from "@tippy.js/react";
import { BiDotsHorizontalRounded } from "react-icons/bi";
import { processMediaUrl } from "../../_helpers/utils";
import { Wrapper } from "../Dashboard/Wrapper";

export default function list(props) {
  const [requesting, setRequesting] = useState(true);
  const [list, setList] = useState([]);
  const [search, setSearch] = useState("");
  const [refreshKey, setRefreshKey] = useState(0);

  const handleDelete = (e) => {
    var id = e.target.id;
    confirmAlert({
      title: "Confirm to delete",
      message: "Are you sure to delete.",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            safetyFeatureService
              .updateStatus({ safetyFeatureId: id, status: "Deleted" })
              .then(
                (objS) => {
                  setRefreshKey((oldKey) => oldKey + 1);
                },
                (error) => {
                  console.log(error);
                }
              );
          },
        },
        {
          label: "No",
          onClick: () => console.log("Click No"),
        },
      ],
    });
  };

  const handleSearch = (e) => {
    setSearch(e.target.value);
    setRequesting(true);
    setRefreshKey((oldKey) => oldKey + 1);
  };

  useEffect(() => {
    safetyFeatureService.list({ search }).then(
      (objS) => {
        setList(objS.data);
        setRequesting(false);
      },
      (error) => {
        console.log(error);
      }
    );
  }, [refreshKey]);
  return (
    <Wrapper showSearch={false} title="Safety feature list">
          <div className="row">
            <div className="col-xl-12">
              <div className="tab-content">
                <div className="tab-pane active show" id="All">
                  <div className="table-responsive">
                    <table
                      className="table card-table  display mb-4 dataTablesCard booking-table room-list-tbl table-responsive-lg "
                      id="guestTable-all"
                    >
                      <thead>
                        <tr>
                          <th>Image</th>
                          <th>Name</th>
                          <th>Status</th>
                          <th>Action</th>
                          <th className="bg-none"></th>
                        </tr>
                      </thead>
                      <tbody>
                        {list.map((data) => (
                          <tr key={data.id}>
                            <td>
                              <div className="guest-bx">
                                <img
                                  src={processMediaUrl(data.image)}
                                />
                              </div>
                            </td>
                            <td>
                              <span className="fs-16">{data.name}</span>
                            </td>
                            <td>
                              <span className="fs-16">{data.status}</span>
                            </td>
                            <td>
                              <div className="tw-w-min">
                                <Tippy
                                  interactive
                                  theme="light"
                                  className="tw-bg-white "
                                  arrow={false}
                                  trigger="mouseenter"
                                  content={
                                    <div className="">
                                      <ul class=" tw-bg-white tw-shadow-md tw-p-2 tw-m-4">
                                        <li class="tw-text-sm tw-text-gray-700">
                                          <Link
                                            className="tw-block tw-p-2"
                                            to={
                                              "/safetyfeature/edit/" + data.id
                                            }
                                          >
                                            Edit
                                          </Link>
                                        </li>
                                        <li class="tw-text-sm tw-text-gray-700">
                                          <a
                                            className="tw-block tw-p-2"
                                            id={data.id}
                                            key={data.id}
                                            onClick={handleDelete}
                                          >
                                            Delete
                                          </a>
                                        </li>
                                      </ul>
                                    </div>
                                  }
                                >
                                  <div>
                                    <BiDotsHorizontalRounded
                                      className="tw-text-gray-500 tw-cursor-pointer"
                                      size={24}
                                    />
                                  </div>
                                </Tippy>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            {requesting && (
              <div className="tw-my-10 tw-flex tw-items-center tw-justify-center">
                <div className="bg-white tw-w-max rounded shadow-md p-4">
                  <div className="loader"></div>
                </div>
              </div>
            )}
          </div>
      <Footer />
    </Wrapper>
  );
}
